import React, {
  useEffect,
  useCallback,
  useContext,
  useState,
  useRef,
} from "react";
import EntriesDataContext from "../../../context/EntriesDataContext";
import { ReactSession } from "react-client-session";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";

import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { getSuccessToast, getErrorToast } from "../../../toast";
import { toast } from "react-toastify";
import CNDATA from "../../pages/CNDATA";
import "./RecentEntriesTable.css";
import download from "../../../assets/download.svg";
import download_2 from "../../../assets/download_2.svg";
import edit from "../../../assets/edit.svg";
import Cancel from "../../../assets/cancel.svg";
import submit from "../../../assets/submit.svg";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import ReconcilationHandler from "../../reconcilation/ReconcilationHandler.jsx";
import CNDialog from "../../dialog/CNDialog.jsx";
import ScanButtton from "../../button/ScanButtton.jsx";
var fileDownload = require("js-file-download");

const RecentEntriesTable = () => {
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  const { resData, setResData, redirectId, setRedirectId } =
    useContext(EntriesDataContext);
  const [rowData, setRowData] = useState([]);
  const [searched, setSearched] = useState("");
  const [editState, setEditState] = useState(false);
  const [boxId, setBoxId] = useState();
  const username = ReactSession.get("username");
  const [poNo, setPoNo] = useState();
  const [partyName, setPartyName] = useState();
  const [partyList, setPartyList] = useState([]);
  const [partyId, setPartyId] = useState();
  const [partyCode, setPartyCode] = useState();
  const [city, setCity] = useState("");
  const [checked, setChecked] = useState(false);
  const [lrNo, setLrNo] = useState();
  const [lrDate, setLrDate] = useState();
  const [caseNo, setCaseNo] = useState();
  const [goodsType, setGoodsType] = useState();
  const [receivedDate, setReceivedDate] = useState();
  const [refNo, setRefNo] = useState();
  const [refDate, setRefDate] = useState();
  const [transporterName, setTransporterName] = useState();
  const [srNo, setSrNo] = useState();
  const partyNameRef = useRef("");
  const [loading, setLoading] = useState();
  const [open, setOpen] = useState(false);
  const [currentCNRecord, setCurrentCNRecord] = useState({});

  const [cnDialogOpen, setCnDialogOpen] = useState(false);
  const [currentBoxId, setCurrentBoxId] = useState(null);

  const columns = [
    {
      id: "sr_no",
      width: "4rem",
      label: "Sr No",
      position: "sticky",
      left: "0%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "po_no",
      width: "5rem",
      label: "S. No",
      position: "sticky",
      left: "4%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "party_name",
      width: "8rem",
      label: "Party Name",
      position: "sticky",
      left: "10%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "party_code",
      width: "8rem",
      label: "Party Code",
      position: "sticky",
      left: "20%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "city",
      width: "6rem",
      label: "City",
      position: "sticky",
      left: "27%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "status",
      width: "2rem",
      label: "Status",
      position: "sticky",
      left: "36%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "lr_no",
      width: "8rem",
      label: "LR No",
      position: "sticky",
      left: "38%",
      backgroundColor: "black",
      z: "1",
      color: "white",
    },
    {
      id: "lr_date",
      width: "5rem",
      label: "LR Date",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "ref_no",
      width: "7rem",
      label: "Claim No.",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "ref_date",
      width: "5rem",
      label: "Claim Date",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "received_date",
      width: "5rem",
      label: "Received Date",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },

    {
      id: "case_no",
      width: "5rem",
      label: "No of cases",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "transporter_name",
      width: "9rem",
      label: "Transporter Name",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "date",
      width: "5rem",
      label: "Date",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
    {
      id: "actions",
      width: "10rem",
      label: "Actions",
      position: "",
      left: "rem",
      backgroundColor: "black",
      z: "0",
      color: "white",
    },
  ];

  const getRecentEntries = useCallback(async () => {
    try {
      const response = await axiosPrivate.get("/dashboard/operatordata/6");
      setResData(response.data.data.slice(0, 6));
      setRowData(response.data.data);
    } catch (error) {
      console.log(error.message);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirectId]);

  useEffect(() => {
    getRecentEntries();
  }, [getRecentEntries]);

  function addSpaces(str) {
    const newStr = str.replaceAll(",", ", ");

    return newStr;
  }

  const handleDownload = async (id) => {
    const partyINFO = await axiosPrivate.get(`/data_entry/party-info/${id}/`);
    axiosPrivate
      .get(`/report/download-report/${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        let date = new Date();
        fileDownload(
          response.data,
          `${partyINFO.data["party_code"]}_${formatDate(date)}.xlsx`
        );
        setRedirectId((prev) => prev + 1);
      })
      .catch((error) => {
        if (error.response["status"] === 501) {
          getErrorToast("Expired medicine is not available in claim.", 1000);
        }
      });
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [day, month, year].join("-");
  }

  const changePartyNameHandler = (e) => {
    setPartyName(e.target.value);
    if (partyNameRef.current.value === "") {
      setPartyCode("");
      setPartyId("");
      setCity("");
    }

    axiosPrivate
      .get(`/data_entry/partymaster_searchbar/?search=${e.target.value}`)
      .then((res) => {
        setPartyList(res.data.results);
      });

    let partyName = partyNameRef.current.value
      .substring(0, partyNameRef.current.value.lastIndexOf(" "))
      .trim();
    let partyCode = partyNameRef.current.value
      .substring(partyNameRef.current.value.lastIndexOf(" "))
      .trim();

    const filteredList = partyList.filter(
      (name) => name["name"] === partyName && name["customer"] === partyCode
    )[0];

    if (filteredList !== undefined) {
      setPartyName(filteredList["name"]);
      setPartyCode(filteredList["customer"]);
      setPartyId(filteredList["party_master_id"]);

      if (filteredList["city"]) {
        setCity(filteredList["city"]);
      } else {
        setCity("");
      }
    }
  };

  const editHandler = (boxId) => {
    rowData.filter((row) => {
      if (row.stockists_master_id === boxId) {
        setBoxId(row.stockists_master_id);
        setEditState(true);

        setPoNo(row.po_number);
        setSrNo(row.serial_number);
        setPartyName(row.party_master__name);
        setPartyCode(row.party_master__customer);
        setCity(row.party_master__city);
        setChecked(row.mark_box);
        setLrNo(row.lr_number);
        setLrDate(row.lr_date);
        setCaseNo(row.case_number);
        setGoodsType(row.goods_type);
        setReceivedDate(row.received_date);
        // setOpenDate(row.open_date);
        setRefNo(row.ref_number);
        setRefDate(row.ref_date);
        setTransporterName(row.transporter_name);
      }
    });
  };

  const updateBoxHandler = (boxId) => {
    const data = {
      po_number: poNo,
      party_master_id: partyId,
      party_master__party_name: partyName,
      party_master__party_code: partyCode,
      party_master__city: city,
      mark_box: checked,
      lr_number: lrNo,
      lr_date: lrDate,
      case_number: caseNo,
      received_date: receivedDate,
      ref_number: refNo,
      ref_date: refDate,
      transporter_name: transporterName,
    };

    for (const key in data) {
      if (data[key] === "") {
        getErrorToast(`Please fill ${key.replaceAll("_", " ").toUpperCase()}`);
        return;
      }
    }

    axiosPrivate
      .patch(`/dashboard/editstockistsdata/${boxId}/`, data)
      .then((res) => {
        if (res.status === 200) {
          getSuccessToast("Data updated successfully", 2000);
          setRedirectId((prev) => prev + 1);
        }
      });
    setEditState(false);
  };

  const searchBarHandler = (e) => {
    axiosPrivate
      .get(`/dashboard/search_stockistsdata/?search=${e.target.value}`)
      .then((response) => {
        setResData(response.data.results.slice(0, 6));
        setRowData(response.data.results);
      });
  };

  const handleDownloadSaleable = async (id) => {
    const partyINFO = await axiosPrivate.get(`/data_entry/party-info/${id}/`);
    axiosPrivate
      .get(`/report/download-saleable-report/${id}`, {
        responseType: "blob",
      })
      .then((response) => {
        if (response.status === 200) {
          let date = new Date();
          fileDownload(
            response.data,
            `${partyINFO.data["party_code"]}_Sellable_${formatDate(date)}.xlsx`
          );
        }
        setRedirectId((prev) => prev + 1);
      })
      .catch((error) => {
        if (error.response["status"] === 501) {
          getErrorToast("Sellable medicine is not available in claim.", 1000);
        }
      });
  };

  const RCHandler = (id) => {
    setLoading(true);
    ReactSession.set("box_id", id);
    axiosPrivate
      .get(`reconcilation/reconcile/${id}`)
      .then((res) => {
        console.log(res);
        if (res.data.message) {
          if (res.data.message == "No Scanned Entry for given claim id") {
            navigate("/scan");
          } else {
            if (res.data.bool === true) {
              const data = res.data.data.map((el, i) => {
                return {
                  ...el,
                  sr_no: i + 1,
                };
              });
              navigate("/report", { state: { data: data, img: res.data.img } });
            } else {
              navigate("/reconciled-report", {
                state: { data: res.data.data },
              });
            }
          }
        } else {
          if (res.data.bool === false) {
            navigate("/upload");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const CNHandlerWithOrders = (id, order_types) => {
    setLoading(true);
    const apiToast = toast.loading("API Called!", {
      type: "info",
      theme: "colored",
    });

    const payload = {
      stockists_master_id: id,
      order_types,
    };

    axiosPrivate
      .post(`/data_entry/save-order/`, payload)
      .then((res) => {
        getRecentEntries();
        toast.update(apiToast, {
          render: `success: ${res.data.success} \n message: ${res.data.message}`,
          theme: "colored",
          type: "success",
          isLoading: false,
          autoClose: 2000,
          onClick: () => toast.dismiss(apiToast),
        });
      })
      .catch(() => {
        toast.update(apiToast, {
          render: "Something went wrong!",
          theme: "colored",
          type: "error",
          isLoading: false,
          autoClose: 1500,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const CNDHandler = (row) => {
    setCurrentCNRecord(row);
    setOpen(!open);
  };

  return (
    <>
      <div className="entries-header-container">
        <p className="entries-header-name">Recent Entries</p>
        <input
          placeholder="Search Details"
          className="entries-header-input"
          type="text"
          onChange={searchBarHandler}
        />
      </div>
      <Paper
        style={{
          overflow: "hidden",
        }}
      >
        <TableContainer sx={{ maxHeight: "42.5vh" }}>
          <Table
            // style={{
            //   tableLayout: "fixed",
            // }}
            stickyHeader
            aria-label="sticky table"
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    style={{
                      width: column.width,
                      color: column.color,
                      backgroundColor: "#000000",
                      // position: column.position,
                      // left: column.left,
                      // zIndex: column.z,
                      fontSize: "0.6em",
                      padding: "0.5em",
                      textAlign: "center",
                    }}
                    key={column.id}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {resData.map((row, idx) => (
                <TableRow key={row.stockists_master_id}>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "0%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <>
                        <input
                          style={{
                            width: "100%",
                          }}
                          value={srNo}
                          className="disabled"
                          disabled={true}
                        />
                      </>
                    ) : (
                      <>{idx + 1}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "4%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <>
                        <input
                          style={{
                            width: "100%",
                          }}
                          value={poNo}
                          onChange={(e) => setPoNo(e.target.value)}
                        />
                      </>
                    ) : (
                      <>{row.po_number}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "12%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <span>
                        <input
                          style={{
                            width: "100%",
                            textOverflow: "ellipsis",
                          }}
                          value={partyName}
                          onChange={changePartyNameHandler}
                          onFocus={changePartyNameHandler}
                          list="party-name"
                          ref={partyNameRef}
                        />
                        <datalist id="party-name">
                          {partyList.map((party) => {
                            return (
                              <option
                                value={`${party.name} ${party.customer}`}
                                key={party.party_master_id}
                              >
                                {party.customer} | {party.city}
                              </option>
                            );
                          })}
                        </datalist>
                      </span>
                    ) : (
                      <>{row.party_master__name}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "26%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <>
                        <input
                          style={{
                            width: "100%",
                          }}
                          className="disabled"
                          disabled={true}
                          value={partyCode}
                        />
                      </>
                    ) : (
                      <>{row.party_master__customer}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "34%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <>
                        <input
                          style={{
                            width: "100%",
                          }}
                          className="disabled"
                          disabled={true}
                          value={city}
                        />
                      </>
                    ) : (
                      <>{row.party_master__city}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "44%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                      />
                    ) : (
                      <input
                        readOnly
                        className="box_data_input"
                        type="checkbox"
                        checked={row.mark_box}
                      />
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      //backgroundColor: "#f9f9f9",
                      // position: "sticky",
                      // left: "46%",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        type="text"
                        style={{
                          width: "100%",
                        }}
                        value={lrNo}
                        onChange={(e) => setLrNo(e.target.value)}
                      />
                    ) : (
                      <>{row.lr_number}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        type="date"
                        style={{
                          width: "100%",
                        }}
                        value={lrDate}
                        onChange={(e) => setLrDate(e.target.value)}
                      />
                    ) : (
                      <>{row.lr_date}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                      texWrap: "wrap",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        type="text"
                        style={{
                          width: "100%",
                        }}
                        value={refNo}
                        onChange={(e) => setRefNo(e.target.value)}
                      />
                    ) : (
                      <>{addSpaces(row.ref_number)}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        type="date"
                        style={{
                          width: "100%",
                        }}
                        value={refDate}
                        onChange={(e) => setRefDate(e.target.value)}
                      />
                    ) : (
                      <>{row.ref_date}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        style={{
                          width: "100%",
                        }}
                        type="date"
                        value={receivedDate}
                        onChange={(e) => setReceivedDate(e.target.value)}
                      />
                    ) : (
                      <>{row.received_date}</>
                    )}
                  </TableCell>

                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        style={{
                          width: "100%",
                        }}
                        type="text"
                        value={caseNo}
                        onChange={(e) => setCaseNo(e.target.value)}
                      />
                    ) : (
                      <>{row.case_number}</>
                    )}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        style={{
                          width: "100%",
                        }}
                        type="text"
                        value={transporterName}
                        onChange={(e) => setTransporterName(e.target.value)}
                      />
                    ) : (
                      <>{row.transporter_name}</>
                    )}
                  </TableCell>
                  {/* <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <input
                        style={{
                          width: "100%",
                        }}
                        type="date"
                        value={openDate}
                        onChange={(e) => setOpenDate(e.target.value)}
                      />
                    ) : (
                      <>{row.open_date}</>
                    )}
                  </TableCell> */}
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {formatDate(row.created_on)}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "0.7em",
                      textAlign: "center",
                      padding: "0.5em",
                    }}
                  >
                    {editState && boxId === row.stockists_master_id ? (
                      <>
                        <button
                          onClick={() => {
                            updateBoxHandler(row.stockists_master_id);
                          }}
                          className="table-options-btn"
                        >
                          <img src={submit} alt="submit" />
                        </button>
                        <button
                          className="table-options-btn"
                          onClick={() => setEditState(false)}
                        >
                          <img src={Cancel} alt="cancel" />
                        </button>
                      </>
                    ) : (
                      <div>
                        <button
                          onClick={() =>
                            handleDownload(row.stockists_master_id)
                          }
                          // className="table-options-btn"
                          className={
                            row.indicator["download_indigater_e"] == true
                              ? "table-options-btn-green"
                              : "table-options-btn"
                          }
                        >
                          <img src={download} alt="download" />
                        </button>
                        <button
                          onClick={() =>
                            handleDownloadSaleable(row.stockists_master_id)
                          }
                          className={
                            row.indicator["download_indigater_s"] == true
                              ? "table-options-btn-green"
                              : "table-options-btn"
                          }
                        >
                          <img src={download_2} alt="download" />
                        </button>
                        {editState ? (
                          <button disabled className="table-options-btn">
                            <img src={edit} alt="" />
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              editHandler(row.stockists_master_id);
                            }}
                            className="table-options-btn"
                          >
                            <img src={edit} alt="" />
                          </button>
                        )}
                        <ScanButtton row={row} />
                        <ReconcilationHandler row={row} />
                        {username !== "tester" ? (
                          <>
                            <button
                              onClick={() => {
                                setCurrentBoxId(row.stockists_master_id);
                                setCnDialogOpen(true);
                              }}
                              className={
                                row["indicator"]["returnorder"] === true
                                  ? "table-options-btn-green"
                                  : "table-options-btn"
                              }
                            >
                              CN
                            </button>
                            <CNDialog
                              open={cnDialogOpen}
                              onClose={() => setCnDialogOpen(false)}
                              onSubmit={CNHandlerWithOrders}
                              currentBoxId={currentBoxId}
                            />

                            <button
                              onClick={() => CNDHandler(row)}
                              className="table-options-btn"
                              style={
                                row["cn_date"] === null
                                  ? { display: "none" }
                                  : {}
                              }
                            >
                              CND
                            </button>
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
          <Typography position="absolute">Loading...</Typography>
        </Backdrop>
      )}
      {open && <CNDATA open={open} setOpen={setOpen} data={currentCNRecord} />}
    </>
  );
};

export default RecentEntriesTable;
